import isMobileBrowser from 'is-mobile'

import { DynamicInput, Form } from '@domain-group/suit-theme'

import useCustomField from '@hooks/useCustomField'
import type { UseEntityCustomFieldsFormPayload } from '@hooks/useEntityCustomFieldsForm'

import type { CustomFieldModel } from '@models/customField'

const isMobile = isMobileBrowser()

const mobileSpans = {
  25: 1,
  50: 1,
  75: 2,
  100: 2,
}

const desktopSpans = {
  25: 1,
  50: 2,
  75: 3,
  100: 4,
}

const convertWidthToGridSpan = (fieldWidth: keyof (typeof mobileSpans | typeof desktopSpans)) => {
  if (isMobile){
    return mobileSpans[fieldWidth] || 2
  }

  return desktopSpans[fieldWidth] || 4
}

interface FieldProps {
  customField: CustomFieldModel,
  customFieldsForm: UseEntityCustomFieldsFormPayload,
}

const Field = (props: FieldProps) => {
  const {
    customField,
    customFieldsForm: { entityState, handlers },
  } = props

  const customFieldPayload = useCustomField(customField)
  const {
    customField: {
      field_type,
      key,
      label,
      options: {
        // @ts-expect-error TS2339
        input_type,
      },
    },
    fieldWidth,
    optionValues,
  } = customFieldPayload

  return (
    <Form.Field
      boxProps={{ marginBottom: 'medium' }}
      label={label}
      style={{ gridColumnEnd: `span ${convertWidthToGridSpan(fieldWidth)}` }}
    >
      <DynamicInput
        // @ts-expect-error TS2322
        style={{ height: field_type === 'textarea' ? 80 : null }}
        currentValue={entityState[key] || ''}
        // @ts-expect-error TS2322
        inputComponent={field_type}
        inputType={input_type}
        name={key}
        // @ts-expect-error TS7006
        values={optionValues.map(item => ({ key: item.key, label: item.value }))}
        {...handlers}
      />
    </Form.Field>
  )
}

export default Field
